export const ALBUM_ID = "571fe6ef-bc5c-4bfd-8804-b8e519fb4321"
export const CLOUDINARY_UPLOAD_URL = "https://api.cloudinary.com/v1_1/bloomkeep/upload"
export const CLOUDINARY_PRESET_NAME = "bloomkeep_albums"
export const CLOUDINARY_FOLDER_USER_UPLOADS = "albums/uploads"
export const SUPABASE_URL = "https://hfpwsmqhovyweaejqisy.supabase.co"
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmcHdzbXFob3Z5d2VhZWpxaXN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ3MDE2MjksImV4cCI6MjA3MDI3NzYyOX0.830KKCYrEdjrjJdJAw8PsLwuCILQdG6HdYW7NOO17AY"
export const CLIENT_ID_BLOOMKEEP = "4e99920e-d1aa-4fe5-9e8d-5d376313aced";
export const MAX_MEDIA_DESCRIPTION_LENGTH = 200;
